import script from "./Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=4159dda2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4159dda2"]])

export default __exports__